/**
 * TanStack Router: /results
 *
 * This route file was auto-generated by the route generation script.
 * Component: ResultsPage
 * Layout: Authenticated (_auth)
 *
 * @see scripts/generate-routes.ts
 * @see docs/architecture/tanstack-router-migration-architecture.md
 */
import { createFileRoute } from '@tanstack/react-router'
import ResultsPage from '@/app/results/page'

/**
 * Route: /results
 * Layout: _auth (authenticated)
 * Component: ResultsPage
 */
export const Route = createFileRoute('/_auth/results')({
  component: ResultsPage,
})
